import proj3Imagen from "../assets/img/sem.png";
import proj10Imagen from "../assets/img/fizh&chipss-2.png";
import proj12Imagen from "../assets/img/EnergySysteem-2.png";
import proj15Imagen from "../assets/img/cogs.png";
import proj16Imagen from "../assets/img/chimpaquiz.png";
import proj17Imagen from "../assets/img/chatbot-proj-img.png";


//Project AI
import flask from "../assets/img/flask.svg";
import tensorflow from "../assets/img/tensorflow.svg";
import python from "../assets/img/python.svg";
import rasa from "../assets/img/rasa.svg";
//Project Web
import csharp from "../assets/img/csharp.svg";
//Project Blockchain
import nodejs from "../assets/img/nodejs.svg";
import reactjs from "../assets/img/reactjs.svg";
import ipfs from "../assets/img/ipfs.svg";


//Project Unity Game
import unity from "../assets/img/unity.svg";
//Project Fizh&Chips
//Project Fizh&Chips
import cplus from "../assets/img/cplus.svg";
import cmake from "../assets/img/cmake.svg";
//Project game engineering
import java from "../assets/img/java.svg";
import firebase from "../assets/img/firebase.svg";
//Project software engineering methods
import docker from "../assets/img/docker.svg";
import mysql from "../assets/img/mysql.svg";


import ecg from "../assets/img/ecg.png"




const timelineElements = [

    {
        date: 'Enero 2026 - Presente',
        title: 'Desarrollador Junior en Plexus Tech',
        description: 'Actualmente trabajando en Plexus Tech como Desarrollador Junior, comencé en enero de 2026 en una posición híbrida, con base en Milton Keynes cerca de Londres.',
        imgUrl: null,
        technologies: ['Java', 'Git', 'Bitbucket', 'Confluence', 'AGILE', 'SOLID', 'CI/CD', 'Estrategia de Ramas'],
        tech_definitions: {
            'Java': "Un lenguaje de programación de alto nivel y orientado a objetos ampliamente utilizado para construir aplicaciones empresariales.",
            'Git': "Un sistema de control de versiones distribuido para rastrear cambios en el código fuente durante el desarrollo de software.",
            'Bitbucket': "Un servicio de alojamiento de repositorios de código fuente basado en Git propiedad de Atlassian, utilizado para control de versiones y colaboración.",
            'Confluence': "Una herramienta de colaboración desarrollada por Atlassian para crear, compartir y colaborar en documentación de proyectos y bases de conocimiento.",
            'AGILE': "Un enfoque iterativo para la gestión de proyectos y el desarrollo de software que enfatiza la flexibilidad y la colaboración.",
            'SOLID': "Un conjunto de principios de diseño para escribir software mantenible y extensible: Responsabilidad Única, Abierto-Cerrado, Sustitución de Liskov, Segregación de Interfaces e Inversión de Dependencias.",
            'CI/CD': "Prácticas de Integración Continua y Despliegue Continuo para automatizar el proceso de lanzamiento de software.",
            'Estrategia de Ramas': "Un flujo de trabajo de versionado que define cómo se crean, fusionan y gestionan las ramas en un repositorio Git."
        },
        languages_frameworks: [],
        additionalLinks: [],
        showInProjects: false
    },
    {
        date: 'Septiembre 2024',
        title: 'Analizador de ECG',
        description: 'Un analizador de electrocardiogramas (ECG) basado en aprendizaje automático que procesa y clasifica señales ECG mediante una Red Neuronal Convolucional 1D (1D-CNN). El modelo se entrena con conjuntos de datos en formato CSV para detectar y clasificar afecciones cardíacas como normales o anormales. El sistema está desarrollado con Python y Flask para el procesamiento en el backend, React para el frontend y CSV para la entrada de datos estructurados. El modelo 1D-CNN extrae características clave de las señales de ECG, permitiendo una clasificación precisa de las condiciones cardíacas.',
        imgUrl: ecg,
        technologies: ['Python', 'Flask', 'IA' ,'Aprendizaje Automático', 'React', 'CSV', 'ECG', '1D-CNN', 'CNN', 'Red Neuronal Convolucional'],
        tech_definitions: {
            'Python': "Un lenguaje de programación interpretado y de alto nivel ampliamente utilizado en el procesamiento de datos, aprendizaje automático y desarrollo backend.",
            'Flask': "Un framework web ligero para Python, que permite el procesamiento backend y la comunicación mediante API.",
            'Aprendizaje Automático': "Una rama de la inteligencia artificial enfocada en entrenar modelos para reconocer patrones en datos de ECG y realizar clasificaciones.",
            'React': "Una biblioteca de JavaScript utilizada para construir interfaces de usuario dinámicas e interactivas para la visualización de ECG.",
            'CSV': "Un formato de archivo (Valores Separados por Comas) utilizado para almacenar y gestionar conjuntos de datos estructurados de ECG.",
            'Análisis de ECG': "El proceso de examinar señales de electrocardiograma para detectar anomalías y clasificar afecciones cardíacas.",
            '1D-CNN': "Un tipo de Red Neuronal Convolucional diseñada para procesar datos secuenciales, como señales de ECG, extrayendo patrones temporales para su clasificación."
        },
        languages_frameworks: [python, flask, reactjs, tensorflow],
        additionalLinks: [
                {
                    url: "https://github.com/Carlosjr5/ecg-analyzer.git",
                    text: "Github Repo",
                },

        ],
    },
    {
        date: 'Abril 2024',
        title: 'Aprendizaje Automático para IA Conversacional',
        description: 'Chatbot potenciado por IA para ayudar a los estudiantes a elegir una carrera en Ciencias de la Computación, proporcionando información sobre los resultados de aprendizaje, el futuro profesional y un enlace para encontrar dónde aplicar a los cursos relacionados.',
        imgUrl: proj17Imagen,
        technologies: ['Python', 'Aprendizaje Automático', 'NLP', 'NLU', 'IA'],
        tech_definitions: {
            'Python': "Un lenguaje de programación de alto nivel e interpretado, valorado por su simplicidad y legibilidad.",
            'Aprendizaje Automático': "Un subcampo de la inteligencia artificial enfocado en desarrollar algoritmos que permitan a las computadoras aprender de los datos.",
            'NLP': "Una rama de la inteligencia artificial que se ocupa de permitir que las computadoras comprendan, interpreten y generen lenguaje humano.",
            'NLU': "Un subcampo de NLP enfocado en permitir que las computadoras comprendan el significado y la intención detrás del lenguaje humano.",
            'IA': "La simulación de procesos de inteligencia humana por parte de máquinas, incluyendo el aprendizaje, el razonamiento y la autocorrección."
        },
        languages_frameworks: [python, rasa],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/Career-Advisor-Bot.git",
                text: "Repositorio en Github",
            }
        ],
    },
    {
        key: '2',
        date: 'Junio 2023',
        icon: 'briefcase',
        location: 'Nombre de la Empresa',
        title: 'Desarrollo Full-Stack de una Red Blockchain.',
        description: 'Este proyecto es un estudio para un documento y una implementación de una red blockchain con ciertas capacidades, enfocándose en tener un algoritmo blockchain bien asegurado y estructurado que maneje transacciones y pueda validarlas para agregarlas al bloque en diferentes nodos/peers en la red, los cuales serán guardados como monederos conocidos entre ellos. Además, cuenta con varias características, como chat y un juego de batalla naval. Para desarrollar este sistema, se utilizaron NodeJS, React, IPFS...',
        imgUrl: proj15Imagen,
        technologies: ['NodeJS', 'React', 'Blockchain', 'Criptomoneda', 'Criptografía', 'SHA-256', 'IPFS', 'WEB3'],
        tech_definitions: {
            'NodeJS': "Un entorno de ejecución de JavaScript de código abierto y multiplataforma que ejecuta código JavaScript fuera de un navegador web.",
            'React': "Una biblioteca de JavaScript para construir interfaces de usuario, desarrollada por Facebook, conocida por su enfoque declarativo y basado en componentes.",
            'Blockchain': "Una tecnología de libro mayor distribuido que permite transacciones seguras y transparentes de igual a igual en una red.",
            'Criptomoneda': "Una moneda digital o virtual que utiliza criptografía para la seguridad y opera de manera independiente de un banco central.",
            'Criptografía': "La práctica de desarrollar y usar algoritmos codificados para proteger y ocultar información transmitida.",
            'SHA-256': "Una función hash criptográfica utilizada en la creación de direcciones de Bitcoin y en muchas otras aplicaciones criptográficas como método de encriptación.",
            'IPFS': "IPFS, o InterPlanetary File System, es un protocolo descentralizado para almacenar y compartir contenido hipermedial. Asigna hashes criptográficos únicos al contenido, haciéndolo inmutable y facilitando su recuperación eficiente. El contenido se distribuye a través de una red de peers, promoviendo la resiliencia contra la censura y la pérdida de datos.",
            'WEB3': "Web3 (también conocida como Web 3.0) es una idea para una nueva iteración de la World Wide Web que incorpora conceptos como la descentralización, tecnologías de blockchain y economía basada en tokens."
        },
        languages_frameworks: [nodejs, reactjs, ipfs],
    },
    {
        date: 'Mayo 2023',
        icon: 'graduation-cap',
        location: 'Nombre de la Universidad',
        title: 'Sistema Energético P2P',
        description: 'Sistema Energético P2P utilizando C# y el Framework ActressMAS, evaluando dos protocolos diferentes como "Subasta Doble" y "Subasta de Segundo Precio".',
        imgUrl: proj12Imagen,
        technologies: ['C#', 'P2P', 'Sistema Energético', 'Framework ActressMAS', 'Protocolo de Subasta Doble', 'Protocolo de Subasta de Segundo Precio'],
        tech_definitions: {
            'C#': "Un lenguaje de programación versátil y orientado a objetos desarrollado por Microsoft, comúnmente utilizado para desarrollar videojuegos, aplicaciones web y software de escritorio.",
            'P2P': "La red peer-to-peer (P2P) es un modelo de comunicación descentralizado donde cada participante en la red tiene privilegios y responsabilidades iguales, permitiendo la comunicación directa y el intercambio de recursos entre nodos individuales.",
            'Sistema Energético': "Un sistema que gestiona la generación, distribución y consumo de recursos energéticos, incluyendo electricidad, gas y fuentes de energía renovable, para satisfacer las necesidades de los usuarios o consumidores.",
            'Framework ActressMAS': "Un framework para desarrollar sistemas multi-agente (MAS) en C#, proporcionando herramientas y bibliotecas para modelar, simular y analizar sistemas complejos compuestos por agentes autónomos.",
            'Protocolo de Subasta Doble': "Un tipo de mecanismo de subasta donde tanto los compradores como los vendedores presentan ofertas y demandas, y las transacciones ocurren cuando los precios de oferta y demanda coinciden.",
            'Protocolo de Subasta de Segundo Precio': "Un mecanismo de subasta donde los participantes presentan ofertas selladas, y el postor más alto gana el artículo pero paga el precio presentado por el segundo postor más alto."
        },
        languages_frameworks: [csharp],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/P2P-EnergySystem.git",
                text: "Repositorio en Github",
            }
        ],
    },
    {
        key: '3',
        date: 'Mayo 2022',
        icon: 'gamepad',
        location: 'Unity Game Jam',
        title: 'Juego Chimpaquiz',
        description: 'Desarrollé un juego de disparos en primera persona 3D utilizando Unity y C#. El juego fue hecho para una competencia de Game Jam y cuenta con un sistema de juego interactivo, gráficos atractivos y controles de usuario intuitivos. Fue diseñado para ser jugado directamente en el navegador.',
        imgUrl: proj16Imagen,
        technologies: ['Unity', 'C#', 'Desarrollo de Juegos'],
        tech_definitions: {
            'Unity': "Una plataforma de desarrollo de juegos multiplataforma ampliamente utilizada para crear juegos 2D, 3D, realidad virtual y aumentada.",
            'C#': "Un lenguaje de programación versátil y orientado a objetos desarrollado por Microsoft, comúnmente utilizado para desarrollar videojuegos, aplicaciones web y software de escritorio.",
            'Desarrollo de Juegos': "El proceso de diseñar, crear y lanzar juegos de computadora o consola, que incluye la programación, diseño gráfico, sonido y pruebas."
        },
        languages_frameworks: [csharp, unity, firebase],
        additionalLinks: [
            {
                url: " https://carlosjr23.itch.io/fizhchips",
                text: "Repositorio en Github",
            }
        ],
    },
    {
        key: '7',
        date: 'Mayo 2022',
        icon: 'gamepad',
        location: 'Curso de Desarrollo de Videojuegos',
        title: 'Ingeniería de Videojuegos',
        description: 'Fizh&Chips es un juego desarrollado utilizando el motor CMake y el lenguaje C++. La arquitectura del código incluye archivos principales en C++ para la lógica del juego, con CMake gestionando la compilación. Incluye módulos para gráficos, entrada de usuario, y mecánicas de juego.',
        imgUrl: proj10Imagen,
        technologies: ['C++', 'CMake', 'Desarrollo de Videojuegos', 'Ingeniería de Videojuegos', 'Compras dentro de la Aplicación', 'Integración de Anuncios', 'Diseño de Experiencia de Usuario (UX)'],
        tech_definitions: {
            'C++': "Un lenguaje de programación poderoso y versátil, comúnmente utilizado para desarrollar software de sistemas, motores de juegos y aplicaciones críticas para el rendimiento.",
            'CMake': "Un sistema de construcción de código abierto utilizado para gestionar el proceso de construcción de proyectos de software, proporcionando una forma independiente de la plataforma para especificar y construir programas ejecutables.",
        },

        languages_frameworks: [cplus, cmake],
        additionalLinks: [
            {
                url: " https://carlosjr23.itch.io/fizhchips",
                text: "¡Juega Ahora!",
            },
        ],
    },
    {
        key: '4',
        date: 'Abril 2021',
        icon: 'code',
        location: 'Empresa de Software',
        title: 'Métodos de Ingeniería de Software',
        description: 'Trabajé para una organización que requiere informes sobre información poblacional. Me encargaron diseñar e implementar un nuevo sistema que permita un fácil acceso a esta información poblacional. La organización proporcionó una base de datos SQL para trabajar y obtener detalles utilizando Java, filtrando los resultados que la organización quería obtener de la base de datos utilizando Docker.',
        imgUrl: proj3Imagen,
        technologies: ['Java', 'SQL', 'Docker', 'Sistemas de Gestión de Bases de Datos (DBMS)', 'Filtrado de Datos', 'Diseño de Sistemas', 'CD/CI', 'Ágil'],
        tech_definitions: {
            'Java': "Un lenguaje de programación orientado a objetos ampliamente utilizado, conocido por su independencia de plataforma, flexibilidad y vasto ecosistema de bibliotecas y frameworks.",
            'SQL': "Structured Query Language, un lenguaje específico de dominio utilizado para gestionar y manipular bases de datos relacionales, incluyendo operaciones como consultas, actualizaciones y modificaciones de datos.",
            'Docker': "Una plataforma abierta para desarrollar, enviar y ejecutar aplicaciones en contenedores, permitiendo a los desarrolladores empaquetar sus aplicaciones con todas las dependencias en una unidad estandarizada para facilitar la implementación y la escalabilidad.",
            'Sistemas de Gestión de Bases de Datos (DBMS)': "Sistemas de software utilizados para gestionar y manipular bases de datos, proporcionando características como almacenamiento, recuperación, modificación y seguridad de datos.",
            'Filtrado de Datos': "El proceso de seleccionar y recuperar datos específicos de un conjunto de datos basado en ciertos criterios o condiciones, a menudo utilizado para extraer información relevante de grandes conjuntos de datos.",
            'Diseño de Sistemas': "El proceso de definir la arquitectura, componentes, módulos, interfaces y datos de un sistema para cumplir con los requisitos especificados.",
            'CD/CI': "Integración continua y entrega continua, prácticas de desarrollo que permiten la construcción, prueba y despliegue automáticos de aplicaciones de manera rápida y eficiente.",
            'Metodologías Ágiles': "Enfoques de gestión de proyectos y desarrollo de software que enfatizan la colaboración, la flexibilidad, la entrega incremental y la capacidad de respuesta ante el cambio."
        },
        languages_frameworks: [java, mysql, docker],
        additionalLinks: [
            {
                url: "https://github.com/Carlosjr5/sem",
                text: "Repositorio en Github",
            },
        ],
    }


];

export default timelineElements;